import { imagesFileFormats, videoFileFormats } from "@constants/index";

export const throwImageFiltering = (files: FileList) => {
  const filteredFiles = Array.from(files)
    .filter((file) => {
      if (videoFileFormats.includes(file.type)) {
        if (file.size <= 1 * 1024 * 1024 * 1024) {
          return true;
        }
      }

      if (imagesFileFormats.includes(file.type)) {
        if (file.size <= 20 * 1024 * 1024) {
          return true;
        }
      }

      return false;
    }); // 10MB in bytes

  const newDataTransfer = new DataTransfer();

  filteredFiles.forEach((file) => {
    const newFileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${file.name.split('.').pop()}`;

    const renamedFile = new File([file], newFileName, { type: file.type });

    newDataTransfer.items.add(renamedFile);
  });

  return newDataTransfer.files;
};
